
export const getThemeColor = (theme: any, color?: string) => {
    if (!color) return undefined;
    if (theme?.palette?.[color]) {
        return theme.palette[color].main;
    } else {
        const parts = color.split(".");
        if (parts.length === 2) {
            if (theme?.palette?.[parts[0]]?.[parts[1]])
                return theme.palette[parts[0]][parts[1]];
        }
    }
    return color;
}

export const getWhiteOrBlackForContrast = (color: string) => {
    // Convert hex color to RGB
    const hex = color.startsWith('#') ? color.slice(1) : color;
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return white or black based on luminance
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
}